module.exports = __webpack_public_path__ + "img/person-plus_fill.90b7e1c0.svg";